// @flow strict

import React, { type Node, useRef, useEffect, useState } from 'react';
import * as styles from './responsive-table.module.less';

type ResponsiveTableProps = {
  children: Node,
};

export const ResponsiveTable = ({ children }: ResponsiveTableProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [isScrollable, setIsScrollable] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper) return;

    const checkScrollable = () => {
      setIsScrollable(wrapper.scrollWidth > wrapper.clientWidth + 1);
    };

    const handleScroll = () => {
      setHasScrolled(wrapper.scrollLeft > 0);
    };

    checkScrollable();

    const resizeObserver = new ResizeObserver(checkScrollable);
    resizeObserver.observe(wrapper);

    wrapper.addEventListener('scroll', handleScroll);

    // Re-check once fonts/images settle
    const timer = setTimeout(checkScrollable, 500);

    return () => {
      resizeObserver.disconnect();
      wrapper.removeEventListener('scroll', handleScroll);
      clearTimeout(timer);
    };
  }, []);

  return (
    <div
      ref={wrapperRef}
      className={`${styles.tableWrapper} ${isScrollable ? styles.scrollable : ''} ${hasScrolled ? styles.hasScrolled : ''}`}
    >
      <div className={styles.tableContainer}>
        <table>
          {children}
        </table>
      </div>
    </div>
  );
};
